import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import {
  setFilterDomains,
  setFilterVersionStatus,
  setRefreshCount,
  setFilterDimensions,
  setFilterExtendedStatsDomains,
  setFilterIntervallo,
  setFilterDataDa,
  setFilterDataA,
  setFilterMese,
  setFilterDataProducts,
  setFullTextSearch,
  setIsCompleteSearch,
  setFilterOwner,
} from "../../store/app/DataQualityStatus/DataQualitySlice";
import {
  setFilterProductTypes,
  setFilterStatusCount,
} from "../../store/app/DataRollCall/DataRollCallSlice";
import {
  setFilterProcessType,
} from "../../store/app/ProcessRuns/ProcessRunsSlice";

import moment from "moment";

const FilterSyncer = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const refreshCount = useSelector(
    (state) => state.dataQualityReducer.refreshCount
  );

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);

    dispatch(
      setFilterDomains(
        searchParams.get("domains")
          ? JSON.parse(searchParams.get("domains"))
          : []
      )
    );
    dispatch(
      setFilterExtendedStatsDomains(
        searchParams.get("extendedStatsDomains")
          ? JSON.parse(searchParams.get("extendedStatsDomains"))
          : []
      )
    );
    dispatch(
      setFilterVersionStatus(
        searchParams.get("status") ? JSON.parse(searchParams.get("status")) : []
      )
    );
    dispatch(
      setFilterDimensions(
        searchParams.get("dimensions")
          ? JSON.parse(searchParams.get("dimensions"))
          : []
      )
    );
    dispatch(
      setFilterDataProducts(
        searchParams.get("dataproducts")
          ? JSON.parse(searchParams.get("dataproducts"))
          : []
      )
    );
    dispatch(
      setFilterProcessType(
        searchParams.get("process")
          ? JSON.parse(searchParams.get("process"))
          : []
      )
    );
    dispatch(
      setFilterStatusCount(
        searchParams.get("rollcallstatus")
          ? JSON.parse(searchParams.get("rollcallstatus"))
          : []
      )
    );
    dispatch(
      setFilterProductTypes(
        searchParams.get("producttypes")
          ? JSON.parse(searchParams.get("producttypes"))
          : []
      )
    );
    const intervallo =
      searchParams.get("interval") === null
        ? 24
        : Number(searchParams.get("interval"));
    dispatch(setFilterIntervallo(intervallo));

    let fromDate, toDate;

    if (intervallo >= 0) {
      // Standard: last N hours
      fromDate = moment()
        .subtract(intervallo, "hours")
        .format("YYYY-MM-DD HH:mm:ss");
      toDate = moment().format("YYYY-MM-DD HH:mm:ss");
    } else if (intervallo === -3) {
      // "Tutto" (all)
      fromDate = moment("2000-01-01").format("YYYY-MM-DD 00:00:00");
      toDate = moment().format("YYYY-MM-DD 23:59:59");
    } else if (intervallo === -1 || intervallo === -2) {
      // Custom range or single 24H: use query params if present, else fallback to today
      fromDate =
        searchParams.get("fromDate") || moment().format("YYYY-MM-DD 00:00:00");
      toDate =
        searchParams.get("toDate") || moment().format("YYYY-MM-DD 23:59:59");
    } else {
      // Fallback for any other custom value
      fromDate = moment().format("YYYY-MM-DD 00:00:00");
      toDate = moment().format("YYYY-MM-DD 23:59:59");
    }

    dispatch(setFilterDataDa(fromDate));
    dispatch(setFilterDataA(toDate));
    dispatch(
      setFilterMese(
        searchParams.get("mese") ? Number(searchParams.get("mese")) : 0
      )
    );

    dispatch(setFilterOwner(
      searchParams.get("owner")
        ? JSON.parse(searchParams.get("owner"))
        : ""
    ));
    dispatch(setFullTextSearch(searchParams.get("fulltext") || ""));
    dispatch(setIsCompleteSearch(searchParams.get("isCompleteSearch") === "true"));


    dispatch(setRefreshCount(refreshCount + 1));

    
  }, [location.search]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);

    if (searchParams.has("url") && location.pathname != "/external-redirect") {
      searchParams.delete("url");
      globalThis.history.replaceState(
        {},
        "",
        `${location.pathname}?${searchParams.toString()}`
      );
    }
  }, [location.pathname]);

  return null;
};

export default FilterSyncer;
